import React, { Component } from 'react';
import Main from './components/Main.jsx';

class App extends Component {

	render() {
		return (
			<Main/>
		);
	}
}

export default App;
